import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import TotalModalWrapper from '../../../Model/Share/Normal/TotalModalWrapper';
import EditSettingMessageInput from "./EditSettingMessageInput";

export default function AutoMessageEditModal(props) {
  const { data, storeName, onClickSave, onClickExit } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [settingText, setSettingText] = useState('');

  const MessageInputRef = useRef(null);

  const variableCategories = [
    {
      label: t('messageSend.variable.categoryMember'),
      items: [
        { value: t('messageSend.variable.storeName'), example: storeName },
        { value: t('messageSend.variable.userName'), example: t('messageSend.variable.example.userName') },
        { value: t('messageSend.variable.membershipName'), example: t('messageSend.variable.example.membershipName') },
        { value: t('messageSend.variable.exercisePeriod'), example: t('messageSend.variable.example.exercisePeriod') },
        { value: t('messageSend.variable.lockerName'), example: t('messageSend.variable.example.lockerName') },
      ]
    },
    {
      label: t('messageSend.variable.categoryClassReserve'),
      items: [
        { value: t('messageSend.variable.coachName'), example: t('messageSend.variable.example.coachName') },
        { value: t('messageSend.variable.className'), example: t('messageSend.variable.example.className') },
        { value: t('messageSend.variable.reserveTime'), example: t('messageSend.variable.example.reserveTime') },
        { value: t('messageSend.variable.classTime'), example: t('messageSend.variable.example.classTime') },
      ]
    },
    {
      label: t('messageSend.variable.categoryHolding'),
      columns: 1,
      items: [
        { value: t('messageSend.variable.holdingStartDate'), example: t('messageSend.variable.example.holdingStartDate') },
        { value: t('messageSend.variable.holdingEndDate'), example: t('messageSend.variable.example.holdingEndDate') },
      ]
    }
  ];

  // 데이터 세팅 //
  useEffect(() => {
    if (data === undefined) {
      setSettingText('');
    }
    else {
      let newData = data.text.replaceAll('{store_name}', t('messageSend.variable.storeName'))
        .replaceAll('{user_name}', t('messageSend.variable.userName'))
        .replaceAll('{membership_name}', t('messageSend.variable.membershipName'))
        .replaceAll('{exercise_period}', t('messageSend.variable.exercisePeriod'))
        .replaceAll('{locker_name}', t('messageSend.variable.lockerName'))
        .replaceAll('{coach_name}', t('messageSend.variable.coachName'))
        .replaceAll('{class_name}', t('messageSend.variable.className'))
        .replaceAll('{reserve_time}', t('messageSend.variable.reserveTime'))
        .replaceAll('{class_time}', t('messageSend.variable.classTime'))
        .replaceAll('{holding_start_date}', t('messageSend.variable.holdingStartDate'))
        .replaceAll('{holding_end_date}', t('messageSend.variable.holdingEndDate'));

      setSettingText(newData);
    }
  }, [data])

  // 타이틀 부가설명 정리 //
  function decideTitleExplanation() {
    if (data === undefined) return t('messageSend.editModal.descNewRegistration');
    else if (data.division === 'NewRegistration') return t('messageSend.editModal.descNewRegistration');
    else if (data.division === 'ReRegistration') return t('messageSend.editModal.descReRegistration');
    else if (data.division === 'Attendance') return t('messageSend.editModal.descAttendance');
    else if (data.division === 'LastAttendance') return t('messageSend.editModal.descLastAttendance', { day: data.applyDay, time: data.applyTime });
    else if (data.division === 'OnReserve') return t('messageSend.editModal.descOnReserve');
    else if (data.division === 'CancelReserve') return t('messageSend.editModal.descCancelReserve');
    else if (data.division === 'BeforeReserve') return t('messageSend.editModal.descBeforeReserve', { time: data.applyTime });
    else if (data.division === 'Absence') return t('messageSend.editModal.descAbsence');
    else if (data.division === 'BeExpiredMembership') return t('messageSend.editModal.descBeExpiredMembership', { day: data.applyDay, time: data.applyTime });
    else if (data.division === 'BeExpiredLocker') return t('messageSend.editModal.descBeExpiredLocker', { day: data.applyDay, time: data.applyTime });
    else if (data.division === 'ExpiredMembership') return t('messageSend.editModal.descExpiredMembership', { time: data.applyTime });
    else if (data.division === 'HadBeenExpiredMembership') return t('messageSend.editModal.descHadBeenExpiredMembership', { day: data.applyDay, time: data.applyTime });
    else if (data.division === 'HadBeenExpiredLocker') return t('messageSend.editModal.descHadBeenExpiredLocker', { day: data.applyDay, time: data.applyTime });
    else if (data.division === 'ApplyMembershipHolding') return t('messageSend.editModal.descApplyMembershipHolding');
    else if (data.division === 'StartMembershipHolding') return t('messageSend.editModal.descStartMembershipHolding', { day: data.applyDay, time: data.applyTime });
  }
  
  // 변수 입력 거르기 //
  function onChangeSettingText(value) {
    setSettingText(value);
  }

  // 변수 클릭시 텍스트에 추가 //
  function onClickValue(value) {
    MessageInputRef.current.insertVariable(value);
  }

  // 저장 클릭시 //
  function onClickSaveButton() {
    let testText = settingText.replaceAll(t('messageSend.variable.storeName'), '')
                              .replaceAll(t('messageSend.variable.userName'), '')
                              .replaceAll(t('messageSend.variable.membershipName'), '')
                              .replaceAll(t('messageSend.variable.exercisePeriod'), '')
                              .replaceAll(t('messageSend.variable.lockerName'), '')
                              .replaceAll(t('messageSend.variable.coachName'), '')
                              .replaceAll(t('messageSend.variable.className'), '')
                              .replaceAll(t('messageSend.variable.reserveTime'), '')
                              .replaceAll(t('messageSend.variable.classTime'), '')
                              .replaceAll(t('messageSend.variable.holdingStartDate'), '')
                              .replaceAll(t('messageSend.variable.holdingEndDate'), '');

    
    // 이모티콘 감지
    const emojiPattern = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    const emojis = testText.match(emojiPattern);

    // 이모티콘이 있는경우 //
    if (emojis) {
      alert(t('messageSend.editModal.alertNoEmoji'));
      return;
    }

    onClickSave(settingText.replaceAll(t('messageSend.variable.storeName'), '{store_name}')
                            .replaceAll(t('messageSend.variable.userName'), '{user_name}')
                            .replaceAll(t('messageSend.variable.membershipName'), '{membership_name}')
                            .replaceAll(t('messageSend.variable.exercisePeriod'), '{exercise_period}')
                            .replaceAll(t('messageSend.variable.lockerName'), '{locker_name}')
                            .replaceAll(t('messageSend.variable.coachName'), '{coach_name}')
                            .replaceAll(t('messageSend.variable.className'), '{class_name}')
                            .replaceAll(t('messageSend.variable.reserveTime'), '{reserve_time}')
                            .replaceAll(t('messageSend.variable.classTime'), '{class_time}')
                            .replaceAll(t('messageSend.variable.holdingStartDate'), '{holding_start_date}')
                            .replaceAll(t('messageSend.variable.holdingEndDate'), '{holding_end_date}'));
  }

  return (
    <TotalModalWrapper keyboardAware>
      <Modal>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} hover='default'>{t('messageSend.editModal.title')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>- {decideTitleExplanation()}</Text>
        </TitleWrapper>
        <InfoBoxWrapper>
          <InfoBoxInnerWrapper width={404}>
            <SelectedInfoTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.editModal.selectVariable')}</Text>
            </SelectedInfoTextWrapper>
            <CategoryWrapper>
              {variableCategories.map((cat, catIdx) => (
                <CategoryItemWrapper key={catIdx}>
                  <CategorySection>
                    <CategoryTitleWrapper>
                      <CategoryDot />
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{cat.label}</Text>
                    </CategoryTitleWrapper>
                    <ValueGridWrapper columns={cat.columns || 2}>
                      {cat.items.map((item, valIdx) => (
                        <ValueItemWrapper key={valIdx}>
                          <ValueBox onClick={() => onClickValue(item.value)}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='pointer'>{item.value.replace(/^\{|\}$/g, '')}</Text>
                          </ValueBox>
                          <ExampleText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} title={item.example}> : {item.example}</ExampleText>
                        </ValueItemWrapper>
                      ))}
                    </ValueGridWrapper>
                  </CategorySection>
                  <CategoryDivisionLineWrapper>
                    {
                      catIdx < variableCategories.length - 1 &&
                      <CategoryDivisionLine />
                    }
                  </CategoryDivisionLineWrapper>
                </CategoryItemWrapper>
              ))}
            </CategoryWrapper>
          </InfoBoxInnerWrapper>
          <DivisionLineWrapper>
            <DivisionLine/>
          </DivisionLineWrapper>
          <InfoBoxInnerWrapper width={450}>
            <InfoBoxInnerRightWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>Content</Text>
              <EditSettingMessageInput
                ref={MessageInputRef}
                value={settingText}
                setValue={onChangeSettingText}
                placeholder="왼쪽에서 선택한 변수가 { } 안에 받는 사람에게 알맞은 값으로 자동 입력되며, 중괄호('{}')를 직접 입력하실 수는 없습니다." />
            </InfoBoxInnerRightWrapper>
          </InfoBoxInnerWrapper>
        </InfoBoxWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{t('messageSend.editModal.cancel')}</Text>
          </ExitButton>
          <SaveButton onClick={onClickSaveButton}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('messageSend.editModal.save')}</Text>
          </SaveButton>
        </ButtonWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  box-sizing: border-box;
  width: 955px;

  border-radius: 10px;
  background-color: ${props => props.theme.background};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;

  gap: 30px;
`;

const InfoBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  min-width: ${props => props.width}px;
  height: 100%;
`;

const InfoBoxInnerRightWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;

const SelectedInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
`;

const CategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 15px;

  width: 100%;

  gap: 20px;
`;

const CategoryItemWrapper = styled.div`
  display: contents;
`;

const CategorySection = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const CategoryDivisionLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const CategoryDivisionLine = styled.div`
  width: calc(100% - 40px);
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const CategoryTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const CategoryDot = styled.div`
  width: 10px;
  height: 10px;

  border-radius: 10px;
  background-color: ${props => props.theme.primary};
`;

const ValueGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 2}, 1fr);

  padding: 0px 10px;

  width: calc(100% - 20px);

  gap: 10px;
`;

const ValueItemWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  min-width: 0;

  gap: 6px;
`;

const ValueBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  padding: 0px 10px;

  height: 28px;

  border-radius: 5px;
  background-color: ${props => props.theme.primaryAlpha20};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DivisionLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  align-self: stretch;
`;

const DivisionLine = styled.div`
  width: 1px;

  height: calc(100% - 40px);

  background-color: ${props => props.theme.line};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 25px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 219px;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;

const ExampleText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  flex: 1;
  min-width: 0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;